// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"b177ce47","977":"45a6107c"}[chunkId] + ".chunk.js";
};